// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__21Igi","radioRow":"SimpleQuestionBuilderModal_radioRow__2fjIk"};